import { InputText } from "@bluframe/blublocks"
import { Template } from "@bluframe/mightychroma-mightytool-frontend-types"

import { ComponentProps } from "."
import { H1, SubtitleH1 } from "./styled"

const HeaderTitle = ({
  errors,
  identifierRef,
  isEditMode,
  isTemplate,
  item,
  nameRef,
  placeholdersRef
}: Pick<
  ComponentProps,
  | "errors"
  | "identifierRef"
  | "isEditMode"
  | "isTemplate"
  | "item"
  | "nameRef"
  | "placeholdersRef"
>) =>
  isEditMode ? (
    <div>
      <InputText
        defaultValue={item?.name}
        error={Boolean(errors?.name)}
        errorText={errors?.name}
        inputId="name"
        label="Name"
        name="name"
        ref={nameRef}
        required
      />

      {isTemplate ? (
        <>
          <InputText
            defaultValue={(item as Template)?.identifier}
            error={Boolean(errors?.identifier)}
            errorText={errors?.identifier}
            inputId="identifier"
            label="Identifier"
            name="identifier"
            ref={identifierRef}
            required
          />

          <InputText
            defaultValue={(item as Template)?.placeholders?.join(",")}
            error={Boolean(errors?.placeholders)}
            errorText={errors?.placeholders}
            infoText="Comma-separated list of placeholders"
            inputId="placeholders"
            label="Placeholders"
            name="placeholders"
            ref={placeholdersRef}
          />
        </>
      ) : null}
    </div>
  ) : (
    <div>
      <H1>{item?.name}</H1>

      {isTemplate ? (
        <SubtitleH1>{(item as Template)?.identifier}</SubtitleH1>
      ) : null}
    </div>
  )

export default HeaderTitle
